package org.solyton.solawi.bid.module.banking.`data`.sepa

import kotlin.collections.List
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.banking.`data`.sepa.collection.SepaCollection
import org.solyton.solawi.bid.module.banking.`data`.sepa.mandate.SepaMandate
import org.solyton.solawi.bid.module.banking.`data`.sepa.message.SepaMessage
import org.solyton.solawi.bid.module.banking.`data`.sepa.message.SepaMessageString
import org.solyton.solawi.bid.module.banking.`data`.sepa.payment.SepaPaymentLink

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaModule.sepaCollections]
 */
@ReadWrite
public val sepaCollections: Lens<SepaModule, List<SepaCollection>> by lazy {
      Lens(
        get = { whole -> whole.sepaCollections },
        set = { part -> { whole -> whole.copy(sepaCollections = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaModule.sepaCollections]
 */
@ReadWrite
public fun SepaModule.sepaCollections(`set`: List<SepaCollection>.() -> List<SepaCollection>):
    SepaModule = copy(sepaCollections = set(sepaCollections))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaModule.sepaMessageString]
 */
@ReadWrite
public val sepaMessageString: Lens<SepaModule, SepaMessageString> by lazy {
      Lens(
        get = { whole -> whole.sepaMessageString },
        set = { part -> { whole -> whole.copy(sepaMessageString = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaModule.sepaMessageString]
 */
@ReadWrite
public fun SepaModule.sepaMessageString(`set`: SepaMessageString.() -> SepaMessageString):
    SepaModule = copy(sepaMessageString = set(sepaMessageString))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaModule.sepaMessages]
 */
@ReadWrite
public val sepaMessages: Lens<SepaModule, List<SepaMessage>> by lazy {
      Lens(
        get = { whole -> whole.sepaMessages },
        set = { part -> { whole -> whole.copy(sepaMessages = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaModule.sepaMessages]
 */
@ReadWrite
public fun SepaModule.sepaMessages(`set`: List<SepaMessage>.() -> List<SepaMessage>): SepaModule =
    copy(sepaMessages = set(sepaMessages))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaModule.sepaMandates]
 */
@ReadWrite
public val sepaMandates: Lens<SepaModule, List<SepaMandate>> by lazy {
      Lens(
        get = { whole -> whole.sepaMandates },
        set = { part -> { whole -> whole.copy(sepaMandates = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaModule.sepaMandates]
 */
@ReadWrite
public fun SepaModule.sepaMandates(`set`: List<SepaMandate>.() -> List<SepaMandate>): SepaModule =
    copy(sepaMandates = set(sepaMandates))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaModule.sepaPaymentLinks]
 */
@ReadWrite
public val sepaPaymentLinks: Lens<SepaModule, List<SepaPaymentLink>> by lazy {
      Lens(
        get = { whole -> whole.sepaPaymentLinks },
        set = { part -> { whole -> whole.copy(sepaPaymentLinks = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaModule.sepaPaymentLinks]
 */
@ReadWrite
public fun SepaModule.sepaPaymentLinks(`set`: List<SepaPaymentLink>.() -> List<SepaPaymentLink>):
    SepaModule = copy(sepaPaymentLinks = set(sepaPaymentLinks))
